import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(en);

// Full ISO 3166-1 list (~250 entries, including dependent territories —
// broader than "just sovereign states") via i18n-iso-countries' "alias"
// mode, which favors common/colloquial names (e.g. "United States",
// "Turkey") over formal ISO short names (e.g. "United States of America",
// "Türkiye") where the library has one on file. This is independent of
// BASE_LANGS/EXTRA_LANGS in constants.js by design — country and base
// language are unrelated, so this list is never filtered by app language
// support.
export const COUNTRIES = Object.values(countries.getNames("en", { select: "alias" }))
  .sort((a, b) => a.localeCompare(b));
